import { useContext, useEffect } from 'react'
import { GlobalContext } from '../Global'
import { getQueryParams } from '../../helpers'
import { SocialLogin } from '../../helpers/socialLogin'

const Auth = ({ csrfToken, children }) => {
  const { dispatch } = useContext(GlobalContext)

  useEffect(() => {
    const params = getQueryParams()

    dispatch({ type: 'changeCsrfToken', payload: csrfToken })
    if (params['code']) {
      SocialLogin(window.localStorage.getItem('providerLast'))
      document.body.style.display = 'none'
    }
    if (params['forgot-password']) {
      dispatch({ type: 'changeForgotType', payload: 'password' })
    }
  }, [dispatch])

  return children
}

export default Auth
